// Mock data for Sri Trinethra Global Projects

export const companyInfo = {
  name: "Sri Trinethra Global Projects",
  tagline: "Real Estate • Investments • Wealth Management",
  description: "Empowering wealth creation through strategic real estate investments and global trading opportunities. Your trusted partner in building lasting financial prosperity.",
  mission: "To provide our members with exclusive access to premium investment opportunities, combining traditional real estate wisdom with modern trading technologies.",
  email: "info@sritrinethraglobal.com",
  phone: "+1 (555) 123-4567",
  address: "123 Financial District, Global Plaza"
};

export const services = [
  {
    id: 1,
    title: "Real Estate Investments",
    description: "Premium commercial and residential properties with high ROI potential. Carefully curated portfolio of global real estate opportunities.",
    icon: "building"
  },
  {
    id: 2,
    title: "Wealth Management",
    description: "Personalized wealth management strategies tailored to your financial goals. Expert advisors to maximize your investment returns.",
    icon: "trending-up"
  },
  {
    id: 3,
    title: "Trading Opportunities",
    description: "Access exclusive trading opportunities in stocks, commodities, and digital assets. Real-time market insights and analytics.",
    icon: "bar-chart"
  }
];

export const realEstateProperties = [
  {
    id: 1,
    title: "Skyline Commercial Tower",
    location: "Downtown Manhattan, NY",
    type: "Commercial",
    price: "$25,000,000",
    expectedROI: "12-15%",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80",
    status: "Available",
    area: "50,000 sq ft",
    description: "Prime commercial property in the heart of Manhattan's financial district."
  },
  {
    id: 2,
    title: "Luxury Residential Complex",
    location: "Miami Beach, FL",
    type: "Residential",
    price: "$18,500,000",
    expectedROI: "10-12%",
    image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&q=80",
    status: "Available",
    area: "75,000 sq ft",
    description: "Oceanfront luxury apartments with premium amenities and stunning views."
  },
  {
    id: 3,
    title: "Tech Park Development",
    location: "Austin, TX",
    type: "Commercial",
    price: "$32,000,000",
    expectedROI: "14-18%",
    image: "https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=800&q=80",
    status: "Pre-Launch",
    area: "100,000 sq ft",
    description: "State-of-the-art technology campus in Austin's innovation corridor."
  },
  {
    id: 4,
    title: "Urban Mixed-Use Center",
    location: "Chicago, IL",
    type: "Mixed-Use",
    price: "$42,000,000",
    expectedROI: "13-16%",
    image: "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=800&q=80",
    status: "Available",
    area: "120,000 sq ft",
    description: "Vibrant mixed-use development combining retail, office, and residential spaces."
  },
  {
    id: 5,
    title: "Waterfront Business Hub",
    location: "San Francisco, CA",
    type: "Commercial",
    price: "$55,000,000",
    expectedROI: "15-20%",
    image: "https://images.unsplash.com/photo-1449844908441-8829872d2607?w=800&q=80",
    status: "Coming Soon",
    area: "85,000 sq ft",
    description: "Premium waterfront commercial space with panoramic bay views."
  },
  {
    id: 6,
    title: "Garden City Residences",
    location: "Seattle, WA",
    type: "Residential",
    price: "$28,000,000",
    expectedROI: "11-14%",
    image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&q=80",
    status: "Available",
    area: "65,000 sq ft",
    description: "Eco-friendly residential community with sustainable living features."
  }
];

export const tradingOpportunities = [
  {
    id: 1,
    symbol: "SPX",
    name: "S&P 500 Index",
    category: "Index Fund",
    currentPrice: "4,783.45",
    change: "+2.34%",
    trend: "up",
    volume: "3.2B",
    marketCap: "42.5T"
  },
  {
    id: 2,
    symbol: "GOLD",
    name: "Gold Futures",
    category: "Commodities",
    currentPrice: "2,045.80",
    change: "+1.12%",
    trend: "up",
    volume: "185M",
    marketCap: "12.8T"
  },
  {
    id: 3,
    symbol: "TECH",
    name: "Technology Sector ETF",
    category: "ETF",
    currentPrice: "156.92",
    change: "-0.45%",
    trend: "down",
    volume: "8.5M",
    marketCap: "285B"
  },
  {
    id: 4,
    symbol: "REIT",
    name: "Real Estate Investment Trust",
    category: "REIT",
    currentPrice: "94.23",
    change: "+3.67%",
    trend: "up",
    volume: "12.3M",
    marketCap: "156B"
  },
  {
    id: 5,
    symbol: "ENERGY",
    name: "Energy Sector Fund",
    category: "Sector Fund",
    currentPrice: "78.45",
    change: "+1.89%",
    trend: "up",
    volume: "6.7M",
    marketCap: "198B"
  },
  {
    id: 6,
    symbol: "INTL",
    name: "International Markets",
    category: "Global Fund",
    currentPrice: "112.67",
    change: "-1.23%",
    trend: "down",
    volume: "4.2M",
    marketCap: "325B"
  }
];

export const marketStats = {
  totalInvestments: "$2.4B",
  activeMembers: "15,420",
  propertiesManaged: "127",
  averageROI: "14.2%"
};

export const chartData = [
  { month: "Jan", value: 4200 },
  { month: "Feb", value: 4350 },
  { month: "Mar", value: 4180 },
  { month: "Apr", value: 4520 },
  { month: "May", value: 4680 },
  { month: "Jun", value: 4783 }
];
